export const getTrousseauFranceData = () => ({
  name: "Trousseau",
  country: "France",
  region: "Jura",
  description: "Le Trousseau est un cépage rare et précieux du Jura, produisant des vins rouges puissants et complexes de grande garde. Ce cépage, avec sa peau épaisse et ses tanins structurés, est considéré comme l'un des plus nobles du Jura. Le Trousseau produit des vins d'une grande complexité aromatique et d'un excellent potentiel de vieillissement.",
  type: "grape",
  color: "Rouge",
  origin: "Jura, France",
  characteristics: {
    "Peau": "Épaisse et colorée",
    "Couleur": "Rouge profond",
    "Acidité": "Moyenne à élevée",
    "Tanins": "Structurés et fermes",
    "Rendement": "Faible à moyen",
    "Maturité": "Tardive"
  },
  aromas: {
    "Primaires": ["Mûre", "Cassis", "Prune", "Cerise noire"],
    "Secondaires": ["Poivre noir", "Réglisse", "Cacao", "Notes épicées"],
    "Tertiaires": ["Truffe", "Cuir", "Tabac", "Notes animales (avec l'âge)"]
  },
  viticulture: {
    "Climat": "Semi-continental avec influences montagneuses",
    "Sol": "Marnes grises et calcaires du Jurassique",
    "Exposition": "Sud et sud-est, exposition chaude",
    "Altitude": "250-400 mètres",
    "Taille": "Guyot simple, taille courte",
    "Rendement": "30-45 hl/ha"
  },
  vinification: {
    "Macération": "Longue (15-25 jours)",
    "Température": "Élevée (28-32°C)",
    "Élevage": "Fûts de chêne neufs et usagés",
    "Durée": "18-24 mois",
    "Spécialités": "Élevage prolongé, assemblage possible"
  },
  wineStyles: {
    "Rouge": "Vins puissants et complexes, couleur profonde, tanins structurés, grande longévité. Vins de garde par excellence.",
    "Assemblage": "Souvent assemblé avec Poulsard et Pinot Noir pour plus de complexité."
  },
  regions: {
    "Jura": {
      "Arbois": "Cœur de production, vins de garde de qualité",
      "Côtes du Jura": "Production généralisée, styles variés"
    }
  },
  statistics: {
    "Surface en France": "100 hectares",
    "Production": "4,000 hectolitres",
    "Concentration": "Jura (100%)",
    "Tendance": "En augmentation"
  },
  history: "Le Trousseau est un cépage ancien du Jura, probablement d'origine locale. Il était déjà cultivé au Moyen Âge et était considéré comme un cépage noble. Le Trousseau a failli disparaître au XXe siècle à cause de sa faible productivité, mais il a été sauvé par des vignerons passionnés. Aujourd'hui, il connaît un regain d'intérêt et est considéré comme l'un des cépages les plus prestigieux du Jura.",
  foodPairing: "Viandes rouges (bœuf, agneau), gibier, fromages affinés (Comté vieux), charcuterie locale, plats en sauce. Les vins de Trousseau sont parfaits pour les repas gastronomiques et les viandes de caractère."
}); 